import { OrderStatus } from '../entities/arrival';
import { PartialDelivery } from '../entities/partialDelivery';
import { UserAccountFactory } from './userAccountFactory';

/**
 * PartialDeliveryファクトリー
 */
export class PartialDeliveryFactory {
  /**
   * PartialDeliveryを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<PartialDelivery> = {}): PartialDelivery => {
    return {
      id: initialData.id ?? (window.crypto as any).randomUUID(), // NOTE: 2025/3/2時点で使っているバージョンのTSの型定義にはrandomUUIDが含まれていない
      organizationId: initialData.organizationId ?? '',
      orderId: initialData.orderId ?? '',
      aggregateBusinessId: initialData.aggregateBusinessId ?? '',
      partialDeliveryNumber: initialData.partialDeliveryNumber ?? '',
      orderCreationTime: initialData.orderCreationTime ?? 0,
      deliveryDate: initialData.deliveryDate ?? 0,
      orderAmount: initialData.orderAmount ?? 0,
      orderStatus: initialData.orderStatus ?? OrderStatus.ApprovedAwaitingDeliveryDate,
      isOutOfStockExpected: initialData.isOutOfStockExpected ?? false,
      lastUpdatedByUser: initialData.lastUpdatedByUser ?? UserAccountFactory.create(),
      orderAlert: initialData.orderAlert ?? [],
      createdAt: initialData.createdAt ?? 0,
      updatedAt: initialData.updatedAt ?? 0,
    };
  };
}
